import { combineReducers } from 'redux';
import { USER_LOGOUT } from './services/user/actionTypes';
import user from './services/user/reducer';
import systemNotifications from './services/systemNotifications/reducer';
import company from './services/company/reducer';
import notification from './services/notification/reducer';
import confirmAction from './services/confirmAction/reducer';
import chat from './services/chat/reducer';

const appReducer = combineReducers({
  user,
  systemNotifications,
  company,
  notification,
  confirmAction,
  chat,
});

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = undefined;
    window.location.href = '/login'
    // window.history.pushState({}, '', "/login")
  }

  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer.js